import { HomeFeature } from "../components/home/GenericFeaturesHomePage";

export const bbClassicFeatures: HomeFeature[] = [
  {
    img:
      "https://frontend-assets.buildbox.com/BB4_BBClassic_Features_Asset_Generator.webp",
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    textAlign: "center",
    topLine: "",
    headline: `AI Asset Generator`,
    description: "Create any game asset you need with a quick prompt. Type your request, click 'Generate', and Buildbox's AI does the rest. Within minutes, you'll receive high-quality game assets, saving you hours of design work.",
    hasLogo: false,
    imgStart: "start",
    alt: "",
    start: "",
    clickableImg: false,
  },
  {
    img:
      "https://frontend-assets.buildbox.com/BB4_BBClassic_Features_DragDropDesign.webp",
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    textAlign: "center",
    topLine: "",
    headline: `Drag, Drop, and Design`,
    description: "Build 2D games fast with Buildbox Classic AI. Drag and drop assets onto the Drop Wheel, customize, and you're done—no coding needed. Prototyping has never been easier.",
    hasLogo: false,
    imgStart: "",
    alt: "",
    start: "",
    clickableImg: false,
  },
  {
    img:
      "https://frontend-assets.buildbox.com/BB4_BBClassic_Features_ReadyMade_Templates.webp",
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    textAlign: "center",
    topLine: "",
    headline: `Ready-Made Templates`,
    description: "Get started quickly with over 40 preset templates. Build platformers, puzzlers, shooters, racing, or sports games without coding. Edit and customize to make each game unique.",
    hasLogo: false,
    imgStart: "start",
    alt: "",
    start: "",
    clickableImg: false,
  },
  {
    img:
      "https://frontend-assets.buildbox.com/BB4_BBClassic_Features_StoryGames_AI.webp",
    lightBg: false,
    lightTopLine: true,
    lightText: true,
    lightTextDesc: true,
    textAlign: "center",
    topLine: "",
    headline: `StoryGames AI`,
    description: "Create visual novel games in minutes with the StoryGames AI feature. Answer a few questions to generate a ten-chapter story with AI-generated art. Customize and expand your game easily.",
    hasLogo: false,
    imgStart: "",
    alt: "",
    start: "",
    clickableImg: false,
  },
];
